import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';

declare let __webpack_public_path__: string;

const getWebpackPublicPathPathname = () => {
  const url = new URL(__webpack_public_path__, window.location.origin);

  return url.pathname;
};

const trimSlashes = (input: string) => {
  return input.replace(/^\/|\/$/g, '');
};

function normalizePublicPath(
  unsanitizedVersion: string | undefined,
  src: string,
) {
  const version = unsanitizedVersion ? trimSlashes(unsanitizedVersion) : '';
  const pathname = trimSlashes(getWebpackPublicPathPathname());
  const baseUrl = trimSlashes(new URL(src).origin);
  const isPathnameIncludesVersion = version
    ? pathname.includes(version)
    : false;

  const publicPath = `${baseUrl}/${pathname ? `${pathname}/` : ''}${version && !isPathnameIncludesVersion ? `${version}/` : ''}`;
  return publicPath;
}

// The normalizePublicPath runtime plugin now caches the resolved public
// path per scope and reuses it on subsequent beforeInit calls.
// This prevents other remotes from overriding webpack_public_path with their own script src,
// while allowing each scope to independently resolve its own path.
// See WPX-3339 for more details.
const resolvedPublicPaths: Record<string, string> = {};

const runtimePlugin: () => ModuleFederationRuntimePlugin = () => {
  return {
    name: 'normalizePublicPathPlugin',
    beforeInit(
      params: Parameters<
        NonNullable<ModuleFederationRuntimePlugin['beforeInit']>
      >[0],
    ) {
      const scope = params?.options?.name;
      const cachedPublicPath = scope ? resolvedPublicPaths[scope] : undefined;

      if (cachedPublicPath) {
        __webpack_public_path__ = cachedPublicPath;
        return params;
      }

      const currentScript = document.currentScript as HTMLScriptElement;
      const version = process.env.FEDERATED_REMOTE_VERSION;

      if (currentScript?.src) {
        const publicPath = normalizePublicPath(version, currentScript.src);
        resolvedPublicPaths[scope] = publicPath;
        __webpack_public_path__ = publicPath;
      }

      return params;
    },
  };
};

export default runtimePlugin;
